'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { renderingKinds } from '@haaretz/s-consts';
import React from 'react';
const RenderingKindContext = /*#__PURE__*/ React.createContext(undefined);
const RenderingKindSetter = /*#__PURE__*/ React.createContext(undefined);
export function RenderingKindProvider({ children, value: defaultRenderingKind }) {
    const [renderingKind, setRenderingKind] = React.useState(defaultRenderingKind);
    const renderingKindSetter = React.useCallback((value)=>{
        if (typeof value === 'string' && value.trim() !== '') {
            setRenderingKind(renderingKinds.includes(value) ? value : 'blocked');
        }
    }, []);
    return /*#__PURE__*/ _jsx(RenderingKindContext, {
        value: renderingKind,
        children: /*#__PURE__*/ _jsx(RenderingKindSetter, {
            value: renderingKindSetter,
            children: children
        })
    });
}
export default function useRenderingKind() {
    const context = React.use(RenderingKindContext);
    if (context === undefined) {
        throw new Error('useRenderingKind must be used within a RenderingKindProvider');
    }
    return context;
}
export function useSetRenderingKind() {
    const context = React.use(RenderingKindSetter);
    if (context === undefined) {
        throw new Error('useSetRenderingKind must be used within a RenderingKindProvider');
    }
    return context;
}
export function useRenderingKindAtom() {
    return [
        useRenderingKind(),
        useSetRenderingKind()
    ];
}

//# sourceMappingURL=renderingKindAtom.js.map